module.exports = __webpack_public_path__ + "static/media/file-prescription.b18b0bbe.svg";